import { render, staticRenderFns } from "./ProviderNew.vue?vue&type=template&id=38ee3888"
import script from "./ProviderNew.vue?vue&type=script&lang=ts"
export * from "./ProviderNew.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports